import { render } from "./MyCard.vue?vue&type=template&id=2b3ce11c&scoped=true"
import script from "./MyCard.vue?vue&type=script&lang=js"
export * from "./MyCard.vue?vue&type=script&lang=js"

import "./MyCard.vue?vue&type=style&index=0&id=2b3ce11c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b3ce11c"]])

export default __exports__